// Order summary UI updates

import { state } from '../state';
import {
    calculateSubtotal,
    getCommitmentFee,
    calculateTransactionFee,
    getAmountToPay,
    getBalanceDue,
    hasFreeBag,
    getSelectedItems
} from '../utils/calculations';
import { formatPrice } from '../utils/formatting';

export function updateOrderSummary() {
    // Update selected items list (both mobile and desktop)
    const selectedItems = getSelectedItems();
    const emptyCartHTML = `
        <div class="text-center py-8 opacity-60">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto mb-3 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <p class="text-sm font-semibold mb-1">Your cart is empty</p>
            <p class="text-xs opacity-70">Add items to get started</p>
        </div>
    `;

    const itemsHTML = selectedItems.length === 0 ? emptyCartHTML : `
        <h4 class="font-bold mb-2 text-sm">Items in Cart</h4>
        ${selectedItems.map(product => {
            const qty = state.selections.get(product.id) || 0;
            return `
                <div class="flex items-start gap-2 p-2 bg-base-200 rounded-lg mb-2">
                    <div class="flex-1">
                        <div class="font-semibold text-xs">${product.name}</div>
                        <div class="text-xs opacity-70">Qty: ${qty}</div>
                    </div>
                    <div class="text-right">
                        <div class="font-bold text-primary text-sm">${formatPrice(product.price * qty)}</div>
                        <div class="text-xs opacity-70">${formatPrice(product.price)} each</div>
                    </div>
                </div>
            `;
        }).join('')}
    `;

    // Update cart modal
    const selectedItemsList = document.getElementById('selected-items-list');
    if (selectedItemsList) {
        selectedItemsList.innerHTML = itemsHTML;
    }

    // Update totals
    const subtotal = calculateSubtotal();
    const commitment = getCommitmentFee();
    const transactionFee = calculateTransactionFee();
    const amountToPay = getAmountToPay();
    const balance = getBalanceDue();

    // Update modal totals
    const subtotalEl = document.getElementById('subtotal');
    const commitmentEl = document.getElementById('commitment-fee');
    const transactionFeeEl = document.getElementById('transaction-fee');
    const amountToPayEl = document.getElementById('amount-to-pay');
    const balanceEl = document.getElementById('balance-due');
    const totalEl = document.getElementById('total');

    if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);
    if (commitmentEl) commitmentEl.textContent = formatPrice(commitment);
    if (transactionFeeEl) transactionFeeEl.textContent = formatPrice(transactionFee);
    if (amountToPayEl) amountToPayEl.textContent = formatPrice(amountToPay);
    if (balanceEl) balanceEl.textContent = formatPrice(balance);
    if (totalEl) totalEl.textContent = formatPrice(subtotal);

    // Show/hide free bag notice
    const freeBagNotice = document.getElementById('free-bag-notice');

    if (hasFreeBag()) {
        if (freeBagNotice) freeBagNotice.classList.remove('hidden');
    } else {
        if (freeBagNotice) freeBagNotice.classList.add('hidden');
    }
}

export function updateCheckoutButton() {
    // Button is always enabled - validation happens on click
}

export function resetCheckoutButton() {
    const btn = document.getElementById('checkout-btn') as HTMLButtonElement;
    if (btn) {
        btn.disabled = false;
        btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
            </svg>
            Proceed to Payment
        `;
    }
}
